import { DateTime } from '../../../../../../../features/date-time/date-time';

export const FormCreateDateTime = () => {
  return <DateTime onChange={() => {}} />;
};
